

export const reports_action = (state) => async (dispatch) => {
    let token = JSON.parse(localStorage.getItem('key'));
    let SERVER_URL = process.env.REACT_APP_API_URL;
    const getUsers = await fetch(SERVER_URL + `api/reports/getreportuser`,
        {
            method: 'POST',
           // mode: 'no-cors',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
               
                'authorization': `bearer ${token.value}`
            },
            body: JSON.stringify({
                comp_id: state.comp_id,
                dept_id: state.dept_id,
                user_id: state.user_id,
                perPage: state.perPage,
                pageNo: state.paheNo
            })
        }).then(res => res.json()).
        then(data => {
            dispatch({
                type: "GET_REPORT_USER",
                payload: data,
            }) 
        })
}